import {
  KeyboardTimePicker,
  KeyboardTimePickerProps,
} from "@material-ui/pickers";
import React, { useState } from "react";

const TimeInput = (props: KeyboardTimePickerProps) => {
  const [refreshTime, setRefreshTime] = useState(new Date());

  return (
    <KeyboardTimePicker
          {...props}
          defaultValue={refreshTime}
          initialFocusedDate={new Date()}
          onMouseEnter={() => {
            setRefreshTime(new Date());
          }}
        />
  );
};

export default TimeInput;
